import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import Drivers from '../Drivers';
import { EditDriver, ViewDriver } from '../pages';

const DriversRoutes: RouteObject[] = [
  {
    path: 'drivers',
    element: <Drivers />,
  },
  {
    path: 'drivers/:driverId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.adminOrSupervisor}
        fallback={<ErrorPage code={403} />}
      >
        <EditDriver />
      </Authorize>
    ),
  },
  {
    path: 'drivers/:driverId',
    element: <ViewDriver />,
  },
];

export default DriversRoutes;
